<template>
  <div class="navbarInfo">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-2 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent me-3"
              @click="getData"
            >
              取消
            </button>
            <button
              type="button"
              @click="$refs.submit.click()"
              class="btn btn-light"
            >
              儲存
            </button>
          </div>
          <div class="col-12 text-end mb-3">
            <button
              v-if="form && form.length < 10"
              type="button"
              class="btn btn-transparent"
              @click="addMenu"
            >
              新增選單
            </button>
          </div>
        </div>
      </div>
      <form @submit.prevent="upDate">
        <div class="card mb-3">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle text-nowrap">
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 54px">
                      排序
                    </th>
                    <th scope="col" class="text-center" style="width: 54px">
                      層級
                    </th>
                    <th scope="col" style="width: 350px">類型</th>
                    <th scope="col" style="width: 283px">名稱</th>
                    <th scope="col" style="width: 283px">連結</th>
                    <th scope="col">功能</th>
                  </tr>
                </thead>
                <draggable
                  tag="tbody"
                  v-model="form"
                  handle=".drag"
                  group="form"
                  animation="1000"
                  :move="onMove"
                >
                  <template v-for="(table, index) in form">
                    <tr :key="'table' + table.id">
                      <td colspan="6" class="p-0 border-bottom-0">
                        <table
                          class="table mb-0 align-middle text-nowrap table-menu"
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                class="text-center"
                                style="width: 54px"
                              >
                                排序
                              </th>
                              <th
                                scope="col"
                                class="text-center"
                                style="width: 54px"
                              >
                                層級
                              </th>
                              <th scope="col" style="width: 350px">類型</th>
                              <th scope="col" style="width: 283px">名稱</th>
                              <th scope="col" style="width: 283px">連結</th>
                              <th scope="col">功能</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr :key="'table' + table.id">
                              <td
                                class="drag text-center"
                                style="cursor: all-scroll"
                              >
                                <i class="bi bi-arrows-move"></i>
                              </td>
                              <td class="text-center">I</td>
                              <td>
                                <div class="d-inline-block">
                                  <select
                                    v-model="table.type"
                                    class="form-select"
                                    @change="changeType(index)"
                                  >
                                    <option value="isNull">請選擇類型</option>
                                    <option
                                      v-for="item in typeList[clientId]"
                                      :key="'type' + item.value"
                                      :value="item.value"
                                    >
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="table.type === 'site'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="table.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇頁面名稱
                                    </option>
                                    <option
                                      v-for="item in targetList[clientId]"
                                      :key="'target' + item.value"
                                      :value="item.value"
                                    >
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="table.type === 'article'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="table.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇文章分類
                                    </option>
                                    <option
                                      v-for="category in articleCategory"
                                      :value="category.id"
                                      :key="'articleCategory' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="table.type === 'product'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="table.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇產品分類
                                    </option>
                                    <option
                                      v-for="category in productCategory"
                                      :value="category.id"
                                      :key="'productCategory' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="table.type === 'itinerary'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="table.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇行程分類
                                    </option>
                                    <option
                                      v-for="category in travelCategory"
                                      :value="category.id"
                                      :key="'travelCategory' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                              <td>
                                <input
                                  v-model="table.name"
                                  type="text"
                                  class="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  v-if="
                                    table.type === 'custom' &&
                                    (!table.sub_menu || !table.sub_menu.length)
                                  "
                                  v-model="table.target"
                                  type="text"
                                  class="form-control"
                                />
                                <p
                                  v-else
                                  class="m-0"
                                  :class="{
                                    'text-gray':
                                      table.sub_menu && table.sub_menu.length,
                                  }"
                                >
                                  {{
                                    table.sub_menu && table.sub_menu.length
                                      ? "子選單已啟用，該選單不會有連結"
                                      : getUrl(table.type, table.target)
                                  }}
                                </p>
                              </td>
                              <td>
                                <div class="d-flex flex-nowrap">
                                  <div class="form-check check-icon">
                                    <input
                                      v-model="table.show"
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'show' + index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{ 'text-primary': table.show }"
                                      :for="'show' + index"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="table.show ? '隱藏' : '顯示'"
                                    >
                                      <i
                                        class="bi"
                                        :class="
                                          table.show
                                            ? ' bi-eye-fill'
                                            : 'bi-eye-slash-fill'
                                        "
                                      ></i>
                                    </label>
                                  </div>
                                  <div class="form-check check-icon">
                                    <input
                                      v-model="table.blank"
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'blank' + index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{ 'text-primary': table.blank }"
                                      :for="'blank' + index"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="
                                        table.blank
                                          ? '關閉另開視窗'
                                          : '啟用另開視窗'
                                      "
                                    >
                                      <i
                                        class="bi bi-arrow-up-right-square-fill"
                                      ></i>
                                    </label>
                                  </div>
                                  <div class="check-icon dropdown">
                                    <button
                                      class="btn btn-link"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      data-boundary="viewport"
                                    >
                                      <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <button
                                          class="
                                            btn btn-link
                                            dropdown-item
                                            text-danger
                                            px-3
                                            py-2
                                          "
                                          type="button"
                                          @click="showDeleteModal(index, table.name)"
                                        >
                                          <i class="bi bi-trash me-2"></i>刪除
                                        </button>
                                      </li>
                                      <li
                                        v-if="
                                          table.sub_menu &&
                                          table.sub_menu.length &&
                                          table.sub_menu.length < 10
                                        "
                                      >
                                        <button
                                          class="
                                            btn btn-link
                                            dropdown-item
                                            px-3
                                            py-2
                                          "
                                          type="button"
                                          @click="addSub_menu(table.name)"
                                        >
                                          <i class="bi bi-plus-circle me-2"></i
                                          >新增子選單
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                  <div v-if="!table.sub_menu || !table.sub_menu.length" class="form-check check-icon">
                                    <input
                                      :checked="
                                        table.sub_menu && table.sub_menu.length
                                      "
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'sub_menu' + index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{
                                        'text-primary':
                                          table.sub_menu &&
                                          table.sub_menu.length,
                                      }"
                                      :style="
                                        'cursor:' +
                                        (table.sub_menu && table.sub_menu.length
                                          ? 'default'
                                          : 'pointer')
                                      "
                                      :for="'sub_menu' + index"
                                      @click="showedSub_menu(index)"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="
                                        table.sub_menu && table.sub_menu.length
                                          ? '子選單啟用中'
                                          : '啟用子選單'
                                      "
                                    >
                                      <i class="bi bi-menu-button-fill"></i>
                                    </label>
                                  </div>
                                  <div v-if="table.sub_menu && table.sub_menu.length" class="form-check check-icon">
                                    <input
                                      :checked="table.showSubMenu"
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'showSubMenu' + index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{
                                        'text-primary': table.showSubMenu,
                                      }"
                                      style="cursor: pointer"
                                      :for="'showSubMenu' + index"
                                      @click="toggleShowSubMenu(index)"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="
                                        table.showSubMenu
                                          ? '隱藏子選單'
                                          : '顯示子選單'
                                      "
                                    >
                                      <i class="bi" :class="table.showSubMenu ? 'bi-arrow-up-circle-fill': 'bi-arrow-down-circle-fill'"></i>
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table
                          class="
                            table
                            mb-0
                            align-middle
                            text-nowrap
                            table-light
                            table-sub_menu
                          "
                          :class="{ 'showSubMenu' : table.showSubMenu}"
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                class="text-center"
                                style="width: 54px"
                              >
                                排序
                              </th>
                              <th
                                scope="col"
                                class="text-center"
                                style="width: 54px"
                              >
                                層級
                              </th>
                              <th scope="col" style="width: 350px">類型</th>
                              <th scope="col" style="width: 283px">名稱</th>
                              <th scope="col" style="width: 283px">連結</th>
                              <th scope="col">功能</th>
                            </tr>
                          </thead>
                          <draggable
                            v-model="table.sub_menu"
                            tag="tbody"
                            handle=".sub_drag"
                            :group="'table-sub_menu' + index"
                            animation="1000"
                          >
                            <tr
                              class="sub_menu_tr"
                              v-for="(sub_menu, sub_index) in table.sub_menu"
                              :key="'sub_menu' + table.id + sub_index"
                            >
                              <td
                                class="sub_drag text-center"
                                style="cursor: all-scroll"
                              >
                                <i class="bi bi-arrows-move"></i>
                              </td>
                              <td class="text-center">II</td>
                              <td>
                                <div class="d-inline-block">
                                  <select
                                    v-model="sub_menu.type"
                                    class="form-select"
                                    @change="changeSubType(index, sub_index)"
                                  >
                                    <option value="isNull">請選擇類型</option>
                                    <option
                                      v-for="item in typeList[clientId]"
                                      :key="'type' + item.value"
                                      :value="item.value"
                                    >
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="sub_menu.type === 'site'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="sub_menu.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇頁面名稱
                                    </option>
                                    <option
                                      v-for="item in targetList[clientId]"
                                      :key="'target' + item.value"
                                      :value="item.value"
                                    >
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="sub_menu.type === 'article'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="sub_menu.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇文章分類
                                    </option>
                                    <option
                                      v-for="category in articleCategory"
                                      :value="category.id"
                                      :key="'articleCategorySub' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="sub_menu.type === 'product'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="sub_menu.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇產品分類
                                    </option>
                                    <option
                                      v-for="category in productCategory"
                                      :value="category.id"
                                      :key="'productCategorySub' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                                <div
                                  v-if="sub_menu.type === 'itinerary'"
                                  class="d-inline-block ms-2"
                                >
                                  <select
                                    v-model="sub_menu.target"
                                    class="form-select"
                                  >
                                    <option value="isNull">
                                      請選擇行程分類
                                    </option>
                                    <option
                                      v-for="category in travelCategory"
                                      :value="category.id"
                                      :key="'travelCategorySub' + category.id"
                                    >
                                      {{ category.name }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                              <td>
                                <input
                                  v-model="sub_menu.name"
                                  type="text"
                                  class="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  v-if="sub_menu.type === 'custom'"
                                  v-model="sub_menu.target"
                                  type="text"
                                  class="form-control"
                                />
                                <p v-else class="m-0">
                                  {{ getUrl(sub_menu.type, sub_menu.target) }}
                                </p>
                              </td>
                              <td>
                                <div class="d-flex flex-nowrap">
                                  <div class="form-check check-icon">
                                    <input
                                      v-model="sub_menu.show"
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'sub_menu-show' + index + sub_index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{ 'text-primary': sub_menu.show }"
                                      :for="'sub_menu-show' + index + sub_index"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="sub_menu.show ? '隱藏' : '顯示'"
                                    >
                                      <i
                                        class="bi"
                                        :class="
                                          sub_menu.show
                                            ? ' bi-eye-fill'
                                            : 'bi-eye-slash-fill'
                                        "
                                      ></i>
                                    </label>
                                  </div>
                                  <div class="form-check check-icon">
                                    <input
                                      v-model="sub_menu.blank"
                                      class="form-check-input"
                                      type="checkbox"
                                      :id="'sub_menu-blank' + index + sub_index"
                                    />
                                    <label
                                      class="form-check-label"
                                      :class="{
                                        'text-primary': sub_menu.blank,
                                      }"
                                      :for="
                                        'sub_menu-blank' + index + sub_index
                                      "
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      :title="
                                        sub_menu.blank
                                          ? '關閉另開視窗'
                                          : '啟用另開視窗'
                                      "
                                    >
                                      <i
                                        class="bi bi-arrow-up-right-square-fill"
                                      ></i>
                                    </label>
                                  </div>
                                  <div class="check-icon dropdown">
                                    <button
                                      class="btn btn-link"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      data-boundary="viewport"
                                    >
                                      <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                    >
                                      <li>
                                        <button
                                          class="
                                            btn btn-link
                                            dropdown-item
                                            text-danger
                                            px-3
                                            py-2
                                          "
                                          type="button"
                                          @click="
                                            showDeleteSubMenModal(
                                              index,
                                              sub_index,
                                              sub_menu.name
                                            )
                                          "
                                        >
                                          <i class="bi bi-trash me-2"></i>刪除
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </draggable>
                        </table>
                      </td>
                    </tr>
                  </template>
                </draggable>
              </table>
            </div>
          </div>
        </div>
        <button ref="submit" type="submit" class="d-none"></button>
        <div class="text-end mb-3">
          <button type="button" class="btn btn-secondary me-3" @click="getData">
            取消
          </button>
          <button
            type="button"
            @click="$refs.submit.click()"
            class="btn btn-gradient"
          >
            儲存
          </button>
        </div>
      </form>
    </div>
    <DeleteModal
      :name="isSubMenu ? '子選單' : '選單'"
      :deleteItem="deleteItem"
      @confirmDelete="deleteMenu"
      :undo="true"
    />
  </div>
</template>

<script>
import { navbarInfo } from '@/http/api/navbarInfo.js'
import { product } from '@/http/api/product.js'
import { article } from '@/http/api/article.js'
import { travel } from '@/http/api/travel.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'

export default {
  name: 'NavbarInfo',
  components: {
    draggable,
    Title,
    Breadcrumb,
    DeleteModal
  },
  data () {
    return {
      articleCategory: null,
      deleteItem: '',
      deleteMenuIndex: null,
      deleteMenuSubIndex: null,
      form: null,
      isSubMenu: false,
      menuTemplate: {
        name: '',
        show: true,
        type: 'custom',
        blank: false,
        target: 'isNull',
        showSubMenu: true
      },
      productCategory: null,
      travelCategory: null,
      typeList: {
        furniture: [
          {
            name: '網站連結',
            value: 'site'
          },
          {
            name: '文章模組',
            value: 'article'
          },
          {
            name: '商品模組',
            value: 'product'
          },
          {
            name: '自定網址',
            value: 'custom'
          }
        ],
        acadiatravel: [
          {
            name: '網站連結',
            value: 'site'
          },
          {
            name: '文章模組',
            value: 'article'
          },
          {
            name: '行程模組',
            value: 'itinerary'
          },
          {
            name: '自定網址',
            value: 'custom'
          }
        ]
      },
      targetList: {
        furniture: [
          {
            name: '關於我們',
            value: 'about'
          },
          {
            name: '訂製產品',
            value: 'customize'
          },
          {
            name: '門市資訊',
            value: 'store'
          },
          {
            name: '關於法律與隱私權',
            value: 'policy'
          },
          {
            name: '聯絡我們',
            value: 'contact'
          }
        ],
        acadiatravel: [
          {
            name: '關於我們',
            value: 'about'
          },
          {
            name: '聯絡我們',
            value: 'contact'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['clientName', 'clientId', 'errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    form: {
      handler (data) {
        const vm = this
        if (data) {
          vm.$nextTick(() => vm.InitBootstrapTooltip())
          data.forEach((form, index) => {
            if (!form) {
              vm.form.splice(index, 1)
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetErrMsg',
      'ToggleDeleteModal'
    ]),
    addMenu () {
      const vm = this
      vm.form.push({ ...vm.menuTemplate })
      vm.$set(vm.form[vm.form.length - 1], 'id', Math.random().toString(36))
    },
    addSub_menu (name) {
      const vm = this
      vm.form.forEach((form) => {
        if (form.name === name) {
          form.sub_menu.push({ ...vm.menuTemplate })
        }
      })
    },
    changeType (index) {
      const vm = this
      vm.form[index].target = 'isNull'
    },
    changeSubType (index, subIndex) {
      const vm = this
      vm.form[index].sub_menu[subIndex].target = 'isNull'
    },
    deleteMenu () {
      const vm = this
      vm.ToggleDeleteModal(false)
      if (vm.isSubMenu) {
        vm.form[vm.deleteMenuIndex].sub_menu.splice(vm.deleteMenuSubIndex, 1)
      } else {
        vm.form.splice(vm.deleteMenuIndex, 1)
      }
    },
    getTravelCategory () {
      const vm = this
      travel.getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.travelCategory = data.data.filter(
              (category) => category.parent_id === 0
            )
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getProductCategory () {
      const vm = this
      product.getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.productCategory = data.data.filter(
              (category) => category.parent_id === 0
            )
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getArticleCategory () {
      const vm = this
      article.getCategory('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.articleCategory = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getUrl (type, target) {
      const vm = this
      let url = ''
      switch (type) {
        case 'article':
          url = vm.getArticleUrl(target)
          break
        case 'product':
          url = vm.getProductUrl(target)
          break
        case 'itinerary':
          url = vm.getItineraryUrl(target)
          break
        case 'site':
          url = `/${target}`
          break
      }
      return url
    },
    getArticleUrl (target) {
      const vm = this
      let url = ''
      if (vm.articleCategory && vm.articleCategory.length) {
        vm.articleCategory.forEach((category) => {
          if (Number(category.id) === Number(target)) {
            url = `/article/category/${
              category.static_uri ? category.static_uri : category.id
            }`
          }
        })
      }
      return url
    },
    getProductUrl (target) {
      const vm = this
      let url = ''
      if (vm.productCategory && vm.productCategory.length) {
        vm.productCategory.forEach((category) => {
          if (Number(category.id) === Number(target)) {
            url = `/product/category/${
              category.static_uri ? category.static_uri : category.id
            }`
          }
        })
      }
      return url
    },
    getItineraryUrl (target) {
      const vm = this
      let url = ''
      if (vm.travelCategory && vm.travelCategory.length) {
        vm.travelCategory.forEach((category) => {
          if (Number(category.id) === Number(target)) {
            url = `/itinerary/category/${
              category.static_uri ? category.static_uri : category.id
            }`
          }
        })
      }
      return url
    },
    getData () {
      const vm = this
      vm.Loading()
      navbarInfo.get(vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            const navbarData = data.data
            navbarData.forEach((form) => {
              form.id = Math.random().toString(36)
              form.showSubMenu = true
            })
            vm.form = navbarData
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    initialEvent () {
      const vm = this
      vm.getData()
      vm.getArticleCategory()
      if (vm.clientName === '芳林家居') vm.getProductCategory()
      if (vm.clientName === '燕府旅遊') vm.getTravelCategory()
    },
    onMove (e) {
      if (e.related.className === 'table-sub_menu') return false
      return true
    },
    showDeleteModal (index, title) {
      const vm = this
      vm.deleteMenuIndex = index
      vm.deleteItem = title
      vm.isSubMenu = false
      vm.ToggleDeleteModal(true)
    },
    showDeleteSubMenModal (index, subIndex, title) {
      const vm = this
      vm.deleteMenuIndex = index
      vm.deleteMenuSubIndex = subIndex
      vm.deleteItem = title
      vm.isSubMenu = true
      vm.ToggleDeleteModal(true)
    },
    showedSub_menu (index) {
      const vm = this
      if (!vm.form[index].sub_menu) {
        vm.$set(vm.form[index], 'sub_menu', [])
        vm.form[index].sub_menu.push({ ...vm.menuTemplate })
      } else if (!vm.form[index].sub_menu.length) {
        vm.form[index].sub_menu.push({ ...vm.menuTemplate })
      }
    },
    toggleShowSubMenu (index) {
      const vm = this
      vm.form[index].showSubMenu = !vm.form[index].showSubMenu
    },
    upDate () {
      const vm = this
      vm.form.forEach((element1) => {
        element1.target = String(element1.target)
        if (element1.sub_menu && element1.sub_menu.length) {
          element1.sub_menu.forEach((element2) => {
            element2.target = String(element2.target)
          })
        }
      })
      vm.Loading()
      navbarInfo.update({ bar: vm.form }, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
